export interface ProductBrand {
  ClientKey?: string;  
  Id: string;
  ProductBrandName: string;
  ParentProductBrandId: string;   
}
